import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';
import { BrowserStorageService } from 'src/app/services/browser-storage.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {
  private storageManager: BrowserStorageService = new BrowserStorageService();

  constructor(private themeService: ThemeService) {}

  @Output() filterChange = new EventEmitter<string>();
  @Input() totalAssistanceRequired!: number;

  selectedFilter = this.storageManager.get('isAssistanceRequired')
    ? this.storageManager.get('isAssistanceRequired')
    : 'all';

  setFilter(type: string) {
    this.selectedFilter = type;
    this.storageManager.set('isAssistanceRequired', type);
    this.storageManager.remove('selectedConversation', 'session');
    this.filterChange.emit();
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  isDarkMode(): boolean {
    return this.themeService.isDarkTheme();
  }
}
